import React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState, useMemo } from "react";
import './style.css';
import SchemeModel from 'components/Common/SchemeAvail';
const couponColors = [
  "linear-gradient(135deg, #49a09d, #5f2c82)",
  "linear-gradient(135deg, #b8e994, #78e08f)",
  "linear-gradient(135deg, #33d9b2, #218c74)",
  "linear-gradient(135deg, #ffb8b8, #ff7675)",
  "linear-gradient(135deg, #ff5252, #b33939)",
  "linear-gradient(135deg, #eccc68, #ff9f43)"
];

const CouponCard = ({ couponText }) => {
  const [schemeModel, setSchemeModal] = useState(false);
  const [color, setColor] = useState(false);
  useEffect(() => {
    const randomColorIndex = Math.floor(Math.random() * couponColors.length);
    const color = couponColors[randomColorIndex];
    setColor(color)
  }, []);

  const formattedDate = new Date(couponText.endDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  const cardStyle = {
    background: color,
  };
  const onClickPublish = () => {
    setSchemeModal(true);
  };
  const handlePublishClick = () => {
  };

  return (
    <div id="coupon-container">
      <SchemeModel
        name={''}
        show={schemeModel}
        onPublishClick={handlePublishClick}
        onCloseClick={() => setSchemeModal(false)}
      />
      <div className="coupon-card" style={cardStyle}>
        <h5>{couponText.promotionCode}</h5>
        <p className='text-sm-start mb-2'>Valid Till: {formattedDate}</p>
        <div className="coupon-circle1"></div>
        <div className="coupon-circle2"></div>
        <div style={{ borderTop: "1px dashed #fff" }} className="mb-3"></div>
        {/* <div className="coupon-row">
          <p id="cpnCode">{couponText.promotionCode}</p>
          <p id="cpnBtn" onClick={!couponText.availed ? null : onClickPublish}>
            Avail Now
          </p>
        </div> */}
        <p className='text-sm-start mb-2'>Description: {couponText?.description || ''}</p>
      </div>
    </div>
  );
};

CouponCard.propTypes = {
  couponText: PropTypes.string.isRequired,
};

export default CouponCard;
